const GoogleVerification = () => {
  return (
    <div>
      google-site-verification: googlec333ee9c0f33cd6b.html
    </div>
  );
}

export default GoogleVerification;
